import { useObservable } from '@mindspace-io/react';
import { statisticsQuery, statisticsStore } from './StatisticsStore';
import { facade } from './StatisticsFacade';

export function useStatistics() {
  const [statistics] = useObservable(statisticsQuery.statistics$, null);

  return statistics;
}

export function useStatisticsStoreLoading() {
  const [isLoading] = useObservable(statisticsQuery.loading$, false);

  return isLoading;
}

export function useStatisticsPeriod() {
  const [period] = useObservable(
    statisticsQuery.period$,
    statisticsStore.getValue().period
  );

  return period;
}

export function useStatisticsFacade() {
  return facade;
}
